import { Button, Col, Row } from 'reactstrap';
import { useState } from 'react';
import moment from 'moment';
import LoaDetailsInfo from './LoaDetailsInfo';

interface LoaDetailsInfoListProps {
  workerName?: string;
  loaRecords?: any[];
}

const LoaDetailsInfoList = ({ workerName, loaRecords = [] }: LoaDetailsInfoListProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!Array.isArray(loaRecords) || loaRecords.length === 0) {
    return (
      <div>
        <h4 className="text-center text-muted">No LOA records found</h4>
      </div>
    );
  }

  const sortedRecords = [...loaRecords].reverse();
  const currentRecord = sortedRecords[currentIndex];
  const totalRecords = sortedRecords.length;

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < totalRecords - 1 ? prev + 1 : prev));
  };

  return (
    <div>
      <Row className="mb-2 align-items-center">
        <Col xs="6">
          <h5 className="mb-0">Leave of Absence Records</h5>
          <small className="text-muted">
            Showing {currentIndex + 1} of {totalRecords}
          </small>
        </Col>
        <Col xs="6" className="text-right">
          <small className="text-muted">Registered: {moment(currentRecord.createdAt).format('MM/DD/YYYY HH:mm')}</small>
        </Col>
      </Row>

      <LoaDetailsInfo
        workerName={workerName}
        firstDayOfLoa={currentRecord.firstDayOfLoa}
        lastDayOfLoa={currentRecord.lastDayOfLoa}
        actualStartDate={currentRecord.actualStartDate}
        actualEndDate={currentRecord.actualEndDate}
        typeOfLoa={currentRecord.loaPolicy?.name}
        selectedReason={currentRecord.selectedReason}
        reason={currentRecord.reason}
        additionalNotes={currentRecord.additionalNotes}
        documents={currentRecord.documents}
        loaPolicy={currentRecord.loaPolicy?.name}
        accrual={currentRecord.loaPolicy?.accrual}
        paymentPct={currentRecord.loaPolicy?.paymentPct}
        recordNumber={totalRecords - currentIndex}
        isMostRecent={currentIndex === 0}
      />

      <Row className="mt-3">
        <Col className="d-flex align-items-center justify-content-between">
          <div>
            <Button color="secondary" onClick={handlePrevious} hidden={currentIndex === 0} size="sm">
              <i className="fas fa-chevron-left mr-1"></i>
              Previous
            </Button>
          </div>

          <small className="text-muted">
            {currentIndex + 1} / {totalRecords}
          </small>

          <div>
            <Button color="secondary" onClick={handleNext} hidden={currentIndex === totalRecords - 1} size="sm">
              Next
              <i className="fas fa-chevron-right ml-1"></i>
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LoaDetailsInfoList;
